<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-3" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{$t('Customer-Turnover-Discount-Statistics')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet" :label="$t('Search')"
                append-icon="search"></v-text-field>
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>


          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm4 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm4 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center="">
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>



                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex  xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headers" :rows-per-page-items=[20,100] :items="itemsichat"
                                :search="searchsatilanbilet">
                                <template slot="items" slot-scope="props">


                                  <td class="text-xs-left">{{ props.item.Cari.Kod }}</td>
                                  <td class="text-xs-left">{{ props.item.Cari.Unvan}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.IcHatSatis | moneyformat }}</td>
                                  <td class="text-xs-center">{{ props.item.Tutarlar.IcHatSatisYuzde}}</td>
                                  <td class="text-xs-center">{{ props.item.Tutarlar.IcHatSatisAdet}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.DisHatSatis | moneyformat}}</td>
                                  <td class="text-xs-center">{{ props.item.Tutarlar.DisHatSatisYuzde}}</td>
                                  <td class="text-xs-center">{{ props.item.Tutarlar.DisHatSatisAdet}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.ToplamHatSatis | moneyformat}}</td>
                                  <td class="text-xs-center">{{ props.item.Tutarlar.ToplamHatSatisYuzde}}</td>
                                  <td class="text-xs-center">{{ props.item.Tutarlar.ToplamHatSatisAdet}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.IcHatIade | moneyformat}}</td>
                                  <td class="text-xs-center">{{ props.item.Tutarlar.IcHatIadeYuzde}}</td>
                                  <td class="text-xs-center">{{ props.item.Tutarlar.IcHatIadeAdet}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.DisHatIade | moneyformat}}</td>
                                  <td class="text-xs-center">{{ props.item.Tutarlar.DisHatIadeYuzde}}</td>
                                  <td class="text-xs-center">{{ props.item.Tutarlar.DisHatIadeAdet}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.IcServis | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.DisServis | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.IcIskontoIade | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.DisIskonto | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.IcIadeEdilenServis | moneyformat}}
                                  </td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.DisIadeEdilenServis | moneyformat}}
                                  </td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.IcNetKar | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.DisNetKar | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.IcKomisyon | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.DisKomisyon | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.IcReserve | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.Tutarlar.DisReserve | moneyformat}}</td>

                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                   {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>

                          <v-flex ma-2 xs12 sm12 md12>
                            <v-layout align-center="" justify-center="" fill-height="">
                              <span class="subheading grey--text font-weight-bold">
                                {{ $t('General-Totals') }}
                              </span>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Domestic-Flights-Sales') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcHatSatis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Domestic-Flight-Sales-Percentage')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcHatSatisYuzde }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Number-of-Domestic-Flight-Sales')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcHatSatisAdet }}
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('International-Flight-Sales')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.DisHatSatis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('International-Flight-Sales-Percentage')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.DisHatSatisYuzde}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Number-of-International-Flight-Sales')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.DisHatSatisAdet }}
                                    </span>
                                  </v-layout>
                                </v-flex>


                              </v-layout>
                            </v-card>
                          </v-flex>



                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Total-Sales') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.ToplamHatSatis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Total-Sales-Percentage') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.ToplamHatSatisYuzde }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Total-Sales-Number') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.ToplamHatSatisAdet }}
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Domestic-Flights-Returns') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcHatIade | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Domestic-Flights-Return-Percentage') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcHatIadeYuzde }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold">{{$t('Number-of-Domestic-Flight-Refunds')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcHatIadeAdet }}
                                    </span>
                                  </v-layout>
                                </v-flex>




                              </v-layout>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Domestic-Service')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcServis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('International-Service') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.DisServis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('Domestic-Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcIskonto | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{ $t('International-Discount') }}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.DisIskonto | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>


                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold">{{$t('Refunded-Service-domestic')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcIadeEdilenServis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Refunded-Service-international')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.DisIadeEdilenServis | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Net-Profit-domestic')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcNetKar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('Net-Profit-international')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.DisNetKar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>


                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> Komisyon (iç)
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcKomisyon | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> Komisyon (dış)
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.Diskom | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold">{{$t('Domestic-Flight-Reserve')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcReserve | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('International-Flight-Reserve')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.DisReserve | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm4 md2>
                            <v-card flat class="grey--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>



                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold">{{$t('Domestic-Flight-Reserve')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.IcReserve | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="body-2 grey--text font-weight-bold"> {{$t('International-Flight-Reserve')}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{genelToplam.DisReserve | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">


                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>
                                <cariaracomp v-bind:etiket="$t('Currentcode_label')" :loading="loading" v-bind:value="Rapor.CariKod" v-model="Rapor.CariKod"></cariaracomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <cariaracomp v-bind:etiket="$t('Main-Account')" :loading="loading1" v-bind:value="Rapor.AnaHesap" v-model="Rapor.AnaHesap"></cariaracomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <masrafmerkezicomp v-model="Rapor.Masraf"> </masrafmerkezicomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <havayollaricomp :etiket="$t('Airline-Code')" v-model="havayolubil"></havayollaricomp>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <!-- <v-select :items="Referans" hide-details v-model="Rapor.Referanslar"
                                :label="$t('References-Requested')" multiple item-text="Title" item-value="Kod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <h4> <span>{{ item.Kod }}</span> </h4>
                                  </v-chip>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                  Rapor.Referanslar.length - 1 }} {{ $t('other-record') }})</span>
                                </template>
                              </v-select> -->
                              İstenilen Referanslar
                              <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="ReferansPrm.Kod" >
                              </referansmerkezicomp>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              İstenmeyen Referanslar
                              <!-- <v-select :items="Referans" hide-details v-model="Rapor.NoReferanslar"
                                :label="$t('Unwanted-References')" multiple item-text="Title" item-value="Kod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <h4> <span>{{ item.Kod }}</span> </h4>
                                  </v-chip>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                  Rapor.NoReferanslar.length - 1 }} {{ $t('other-record') }})</span>
                                </template>
                              </v-select> -->
                              <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="NoReferansPrm.Kod" >
                              </referansmerkezicomp>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-select :items="hesapgurubu" hide-details v-model="Rapor.HesapGruplar"
                                :label="$t('Requested-Account-Group')" multiple item-text="Adi" item-value="Kod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <h4> <span>{{ item.Kod }}</span> </h4>
                                  </v-chip>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                Rapor.HesapGruplar.length - 1 }} {{ $t('other-record') }})</span>
                                </template>
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-select :items="hesapgurubu" hide-details v-model="Rapor.NoHesapGruplar"
                                :label="$t('Account-Group-Not-Requested')" multiple item-text="Adi" item-value="Kod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <h4> <span>{{ item.Kod }}</span> </h4>
                                  </v-chip>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                Rapor.NoHesapGruplar.length - 1 }} {{ $t('other-record') }} )</span>
                                </template>
                              </v-select>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-checkbox :label="$t('Taxes-Excluded')" v-model="Rapor.VergiHaric" hide-details="">
                              </v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-checkbox :label="$t('Ceza Tutarını İade Ciro Tutarına Ekleme')" v-model="Rapor.CezaTutariEkle"
                                hide-details=""></v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-checkbox :label="$t('VAT-Deducted')" v-model="Rapor.KdvDus" hide-details=""></v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'


  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        Referans: [],
        hesapgurubu: [],
        sonuc: 0,
        itemscari: [],
        genelToplam: {
          DisHatIade: 0,
          DisHatIadeAdet: 0,
          DisHatIadeYuzde: 0,
          DisHatSatis: 0,
          DisHatSatisAdet: 0,
          DisHatSatisYuzde: 0,
          DisIadeEdilenServis: 0,
          DisIadeServis: 0,
          DisIskonto: 0,
          DisIskontoIade: 0,
          DisKomisyon: 0,
          DisKomisyonIade: 0,
          DisNetKar: 0,
          DisReserve: 0,
          DisServis: 0,
          IcHatIade: 0,
          IcHatIadeAdet: 0,
          IcHatIadeYuzde: 0,
          IcHatSatis: 0,
          IcHatSatisAdet: 0,
          IcHatSatisYuzde: 0,
          IcIadeEdilenServis: 0,
          IcIadeServis: 0,
          IcIskonto: 0,
          IcIskontoIade: 0,
          IcKomisyon: 0,
          IcKomisyonIade: 0,
          IcNetKar: 0,
          IcReserve: 0,
          IcServis: 0,
          ToplamHatSatis: 0,
          ToplamHatSatisAdet: 0,
          ToplamHatSatisYuzde: 0
        },
        bankapositems: [],
        havayolubil: {
          havayolukodu: null,
          formno: null
        },
        referansitems: [],
        evraktipi: [],
        search: '',
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,
       
        Rapor: {
          CariKod: null,
          HavayoluKodu: null,
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          AnaHesap: null,
          Masraf: null,
          HesapGruplar: [],
          NoHesapGruplar: [],
          Referanslar: [],
          NoReferanslar: [],
          VergiHaric: false,
          CezaTutariEkle: false,
          KdvDus: false,
          Kod:''
        },
        ReferansPrm: {
                Kod: null},
                NoReferansPrm: {
                Kod: null,},
        testRefKod:'1',
        valid: true,
        tumsirketler: '',
        loading1: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],

        statecari: [],
        searchcari: '',
        progress: false,
        statecari1: [],
        searchcari1: '',
        progress1: false,
        tooltip: false,
        el: null,
        yok: false,
        itemsichat: [],
        itemsdishat: [],
        masrafmerkezikodu: 'Masraf',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
    
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params3 = {
          CompanyCode: credentials.SirketKodu
        }


        // this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
        //   headers: {
        //     'Authorization': 'Bearer ' + auth.getAuthHeader()
        //   }
        // }).then((response) => {
        //   this.Referans = response.body
        // }, (response) => {
        //   if (response.status === 0) {
        //     this.text1 = 'Service Unavailable'
        //     this.snackbar = true
        //   } else {
        //     this.text1 = 'Service Unavailable'
        //     this.snackbar = true
        //   }
        // })

        this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.hesapgurubu = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      masrafmerkezicomp,
      havayollaricomp,
      yetkidialog,
      cariaracomp
    },
    watch: {

    },
    methods: {
      getparabirimi() {
        return helpers.getparabirimi()
      },
      computed:{
          headers(){
          return [{
            text: this.$t('Accound-Code'),
            value: 'Cari.Kod',
          },
          {
            text: this.$t('Account-Name'),
            value: 'Cari.Unvan',
          },
          {
            text: this.$t('Domestic-Flights-Sales'),
            value: 'Tutarlar.IcHatSatis',
          },
          {
            text: '%',
            value: 'Tutarlar.IcHatSatisYuzde',
          },
          {
            text: this.$t('Number'),
            value: 'Tutarlar.IcHatSatisAdet',
          },
          {
            text: this.$t('International-Flight-Sales'),
            value: 'Tutarlar.DisHatSatis',
          },
          {
            text: '%',
            value: 'Tutarlar.DisHatSatisYuzde',
          },
          {
            text: this.$t('Number'),
            value: 'Tutarlar.DisHatSatisAdet',
          },
          {
            text: this.$t('Total-Sales'),
            value: 'Tutarlar.ToplamHatSatis',
          },
          {
            text: '%',
            value: 'Tutarlar.ToplamHatSatisYuzde',
          },
          {
            text: this.$t('Number'),
            value: 'Tutarlar.ToplamHatSatisAdet',
          },
          {
            text: this.$t('Domestic-Flights-Returns'),
            value: 'Tutarlar.IcHatIade',
          },
          {
            text: '%',
            value: 'Tutarlar.IcHatYuzde',
          },
          {
            text: this.$t('Number'),
            value: 'Tutarlar.IcHatAdet',
          },
          {
            text: 'Dış Hat İade',
            value: 'Tutarlar.DisHatIade',
          },
          {
            text: '%',
            value: 'Tutarlar.DisHatYuzde',
          },
          {
            text: this.$t('Number'),
            value: 'Tutarlar.DisHatAdet',
          },
          {
            text: this.$t('Domestic-Service'),
            value: 'Tutarlar.IcServis',
          },
          {
            text: this.$t('International-Service'),
            value: 'Tutarlar.DisServis',
          },
          {
            text: this.$t('Domestic-Discount'),
            value: 'Tutarlar.IcIskonto',
          },
          {
            text: this.$t('International-Discount'),
            value: 'Tutarlar.DisIskonto',
          },
          {
            text: this.$t('Refunded-Service-domestic'),
            value: 'Tutarlar.IcIadeEdilenServis',
          },
          {
            text: this.$t('Refunded-Service-international'),
            value: 'Tutarlar.DisIadeEdilenServis',
          },
          {
            text: this.$t('Net-Profit-domestic'),
            value: 'Tutarlar.IcNetKar',
          },
          {
            text: this.$t('Net-Profit-international'),
            value: 'Tutarlar.DisNetKar',
          },
          {
            text: 'İç Komisyon',
            value: 'Tutarlar.IcKomisyon',
          },
          {
            text: 'Dış Komisyon',
            value: 'Tutarlar.DisKomisyon',
          },
          {
            text: this.$t('Domestic-Flight-Reserve'),
            value: 'Tutarlar.IcReserve',
          },
          {
            text: this.$t('International-Flight-Reserve'),
            value: 'Tutarlar.DisReserve',
          }
        ]
        },
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })


  }


  function filtrekayit() {

    this.Rapor.Referanslar=[];
    if (this.ReferansPrm.Kod!='' && this.ReferansPrm.Kod!=null)
    {
      this.Rapor.Referanslar.push(this.ReferansPrm.Kod);
    }
    this.Rapor.NoReferanslar=[];
    if (this.NoReferansPrm.Kod!='' && this.NoReferansPrm.Kod!=null)
    {
      this.Rapor.NoReferanslar.push(this.NoReferansPrm.Kod);
    }
   
    this.filtrevarmi = true
    if (this.Rapor.Referanslar.length < 6 && this.Rapor.NoReferanslar.length < 6) {
      if (this.Rapor.HesapGruplar.length < 6 && this.Rapor.NoHesapGruplar.length < 6) {
        this.getList()
        this.dialogfiltre = false
      } else {
        this.text1 = this.$t('You-cannot-pick-more-than-account-codes')
        this.snackbar = true
      }
    } else {
      this.text1 = this.$t('You-cannot-pick-more-than-references')
      this.snackbar = true
    }
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
    this.Rapor.CariKod = null
    this.Rapor.HavayoluKodu = null
    this.Rapor.AnaHesap = null
    this.Rapor.Masraf = null
    this.Rapor.HesapGruplar = []
    this.Rapor.NoHesapGruplar = []
    this.Rapor.Referanslar = []
    this.Rapor.NoReferanslar = []
    this.Rapor.VergiHaric = false
    this.Rapor.CezaTutariEkle = false
    this.Rapor.KdvDus = false
    this.havayolubil.havayolukodu = null
  }

  function getList() {

    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        if (this.havayolubil.havayolukodu != null) {
          this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketReport/CustomerEndorsmentReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.itemsichat = response.body.DetayList
          this.genelToplam = response.body.ToplamTutarlar
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }



  function getListHtml() {
    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var lang = localStorage.getItem('lang')
        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        if (this.havayolubil.havayolukodu != null) {
          this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + "api/TicketReport/CustomerEndorsmentReportHtml", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {

          this.itemsichat = response.body.DetayList
          this.genelToplam = response.body.ToplamTutarlar
          this.progress = false
          this.load1 = true
          if (lang=='en')
{
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title>MÜŞTERİ CİRO VE İSKONTO İSTATİSTİĞİ </title>','<title> CUSTOMER TURNOVER AND DISCOUNT STATISTICS </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>MÜŞTERİ CİRO VE İSKONTO İSTATİSTİĞİ</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>CUSTOMER TURNOVER AND DISCOUNT STATISTICS</font>");
             bodyhtml=bodyhtml.toString().replace("Seçenekler :","Options :");
             bodyhtml=bodyhtml.toString().replace("Fiyat Türü :","Price Type :");
             bodyhtml=bodyhtml.toString().replace("Seçenekler :	","Options :");
             bodyhtml=bodyhtml.toString().replace("Kesen Kişi :","Person Issuing Tickets :");
             bodyhtml=bodyhtml.toString().replace("Hesap Grubu :","Account Group :");

             response.bodyText=bodyhtml;
             
          }
          var blob = new Blob([response.bodyText], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('MusteriCiro') + ".html";
          link.click();

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function getListExcel() {
    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        if (this.havayolubil.havayolukodu != null) {
          this.Rapor.HavayoluKodu = this.havayolubil.havayolukodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + "api/TicketReport/CustomerEndorsmentReportExcel", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {

          this.itemsichat = response.body.DetayList
          this.genelToplam = response.body.ToplamTutarlar
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('MusteriCiro') + ".xlsx";
          link.click();

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function beforeMount() {


  }
</script>
<style>
</style>